import React from "react";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import {
  MdGroups,
  MdNotificationsActive,
  MdOutlineEventAvailable,
} from "react-icons/md";

import mobileAppImage from "../../../assets/mobile_app_image.png";
import "./mobile_app.css";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=pk.landtrack.proptech.club";
const APP_STORE_URL = "https://apps.apple.com/app/id6787122754";

const appFeatures = [
  {
    icon: <MdGroups aria-hidden="true" />,
    title: "Member Network",
    text: "Discover curated real estate, development, finance, and technology leaders.",
  },
  {
    icon: <MdOutlineEventAvailable aria-hidden="true" />,
    title: "Event Access",
    text: "Track official meetups, private sessions, and ecosystem gatherings in one place.",
  },
  {
    icon: <MdNotificationsActive aria-hidden="true" />,
    title: "Deal Alerts",
    text: "Stay close to member spotlights, opportunities, and timely ecosystem updates.",
  },
];

const MobileApp = () => {
  return (
    <section id="mobile_app_section" aria-labelledby="mobile_app_hdng">
      <div id="mobile_app_inner">
        <div id="mobile_app_content">
          {/* <p id="mobile_app_eyebrow">PropTech Club Mobile App</p> */}
          <h2 id="mobile_app_hdng">Ecosystem In Your Hands</h2>
          <p id="mobile_app_txt">
            Members can access the PropTech Club experience through the mobile app,
            built for networking, event discovery, member visibility, and ecosystem
            updates.
          </p>

          <div id="mobile_app_features">
            {appFeatures.map((feature) => (
              <article className="mobile_app_feature" key={feature.title}>
                <span className="mobile_app_feature_icon">{feature.icon}</span>
                <span>
                  <h3>{feature.title}</h3>
                  <p>{feature.text}</p>
                </span>
              </article>
            ))}
          </div>

          <div id="mobile_app_actions">
            <a
              className="mobile_app_store_link"
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download The PropTech Club app on Google Play"
            >
              <FaGooglePlay aria-hidden="true" />
              <span>
                <small>GET IT ON</small>
                <strong>Google Play</strong>
              </span>
            </a>

            <a
              className="mobile_app_store_link"
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download The PropTech Club app on the App Store"
            >
              <FaApple aria-hidden="true" />
              <span>
                <small>DOWNLOAD ON THE</small>
                <strong>App Store</strong>
              </span>
            </a>
          </div>
        </div>

        <div id="mobile_app_visual" aria-hidden="true">
          <div id="mobile_app_image_frame">
            <img src={mobileAppImage} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileApp;
